<script setup>
import { computed, ref } from 'vue';
import FormInput from '@/components/Shared/Form/Input/Index.vue';
import FormButton from '@/components/Shared/Form/Button.vue';

const emit = defineEmits(['purchase']);

const props = defineProps({
  value: {
    type: Number,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  subTitle: {
    type: String,
    required: false,
  },
  descriptions: {
    type: Array,
    default: null,
  },
  errors: {
    type: Object,
    default: null,
  },
  price: {
    type: Number,
    default: null,
  },
  pricePerHour: {
    type: Number,
    default: null,
  },
  showHoursInput: {
    type: Boolean,
    default: false,
  },
});

const processing = ref(false);
const hoursInputMinValue = 4
const hoursInput = ref(hoursInputMinValue);

const price = computed(() => {
  if (props.price !== null) {
    return props.price;
  }

  let hours = hoursInput.value;

  if (hours < hoursInputMinValue){
      return hoursInputMinValue * props.pricePerHour
  }

  return hours * props.pricePerHour;
});
const setProcessing = isProcessing => (processing.value = isProcessing);
const purchase = () => {
  emit('purchase', { service: props.value, hours: parseInt(hoursInput.value), setProcessing });
};
</script>

<template>
  <div class="partner-profile-services-box">
    <div>
      <h2 class="services-box-title">
        <strong>{{ title }}</strong>
      </h2>
    </div>
    <div v-if="subTitle" class="ml-3 pr-8" style="min-height: 96px">
        <div class="mb-4" v-html="subTitle"></div>
    </div>
    <div v-if="descriptions !== null" class="ml-3 services-box-items">
      <div v-for="description in descriptions" class="mb-4 flex">
        <svg class="check-blue-icon" style="min-height: 1.5rem; min-width: 1.5rem">
          <use xlink:href="#check-icon"></use>
        </svg>
        <span>{{ description }}</span>
      </div>
    </div>
    <div class="services-box-price">
      <div class="price_cell">
        <span class="price"><span v-if="price === 2295" style="font-size: 20px;">{{ trans('__JSON__.From') }} </span>
            € {{ price }},00</span>
      </div>
    </div>
    <div v-if="showHoursInput" class="mx-4 mb-3">
      <form-input
        v-model="hoursInput"
        :label-text="trans('__JSON__.Hours')"
        class="bg-white"
        min="4"
        step="1"
        type="number"
      />
        <div v-if="errors.hours" class="alert alert-danger">{{errors.hours}}</div>
    </div>
    <div class="services-box-button">
      <form-button
        :processing="processing"
        :value="trans('__JSON__.Purchase')"
        button-class="button"
        @click="purchase"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.partner-profile {
  &-services-box {
    width: 320px;
    min-width: 320px;
    max-height: 700px;
    border-radius: 10px;
    background: #edf9ff;
    margin-top: 20px;
    padding-bottom: 20px;

    & .services-box-title {
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      line-height: 24px;
      color: #2fabec;
      padding: 20px;
      text-transform: uppercase;
    }

    & .services-box-items {
      padding-right: 10px;
    }

    & .services-box-price {
      font-size: 24px;
      display: flex;
      justify-content: center;
      align-items: flex-end;
    }

    & .services-box-button {
      display: flex;
      justify-content: center;
      align-items: flex-end;
    }
  }
}

.check-blue-icon {
  height: 1.5rem;
  width: 1.5rem;
  margin-right: 10px;
  color: #00a8ff;
}

.price {
  font-size: 2.5rem !important;
}

.price_rate {
  font-size: 1rem !important;
}
</style>
